export default class TipoMonitoramento {
    static get AGRICOLA() {
        return 'AGRICOLA';
    }

    static get SOCIOAMBIENTAL() {
        return 'SOCIOAMBIENTAL';
    }

    static get AGRICOLA_E_SOCIOAMBIENTAL() {
        return 'AGRICOLA_E_SOCIOAMBIENTAL';
    }
}
